/**
 * ZoomControls Component
 * 
 * This component provides zoom in and zoom out controls for a Google Map.
 * It allows users to adjust the zoom level of the map using buttons.
 * 
 * @author FarmCiti Team
 * @version 1.0.0
 */

import React from "react";
import GoogleMapStyle from "../../../assets/stylesheets/map/GoogleMap.module.css";

/**
 * ZoomControls 
 * @param {{ map: google.maps.Map }} props.map - Google map instance
 */
export default function ZoomControls({ map }) {
  if (!map) return null;

  const zoomIn = () => map.setZoom(map.getZoom() + 1);
  const zoomOut = () => map.setZoom(map.getZoom() - 1);

  return (
    <div className={GoogleMapStyle["zoom-controls"]}>
      <button className={GoogleMapStyle["zoom-button"]} onClick={zoomIn}>
        +
      </button>
      <button className={GoogleMapStyle["zoom-button"]} onClick={zoomOut}>
        −
      </button>
    </div>
  );
}